import type { CurrentInsightSetup } from '@testfeed/shopify-contracts'
import { insightOpportunityCopy as copy } from '@testfeed/product-language'

/** The clicked Polaris button is a custom element, so it is an HTMLElement at run time even though its type says otherwise. */
function clickedElement(target: EventTarget): HTMLElement {
  if (target instanceof HTMLElement) return target
  throw new Error('Expected the clicked insight button to be an HTMLElement')
}

/** Compact dashboard CTA; the question, rationale and all comparison text live in the details modal. */
export function InsightOpportunityCard({
  setup,
  pending,
  error,
  onDetails,
}: {
  setup: CurrentInsightSetup
  pending: string | null
  error?: string
  onDetails: (setup: CurrentInsightSetup, trigger: HTMLElement) => void
}) {
  let failure = null
  if (error) failure = <s-banner tone="critical">{error}</s-banner>
  return (
    <section aria-label={copy.regionLabel(setup.productTitle)} data-insight-opportunity={setup.batchId}>
      <s-box background="subdued" borderWidth="small-100" borderColor="base" borderRadius="base" padding="base">
        <s-stack gap="small">
          <s-text fontWeight="semibold">{copy.title(setup.fieldLabel)}</s-text>
          <s-text color="subdued">{copy.currentFinding(setup.figure.customers, setup.figure.buyers)}</s-text>
          <s-text color="subdued">
            {copy.preparedEvidence(
              setup.preparedEvidence.customers,
              setup.preparedEvidence.buyers,
              setup.preparedEvidence.ordersSyncedAt,
            )}
          </s-text>
          <s-text color="subdued">{copy.audienceSummary(setup.audienceLabel)}</s-text>
          <s-stack direction="inline" gap="small">
            <s-button
              variant="primary"
              loading={pending === setup.batchId}
              disabled={pending !== null}
              onClick={(event) => onDetails(setup, clickedElement(event.currentTarget))}
            >
              {copy.test}
            </s-button>
          </s-stack>
          {failure}
        </s-stack>
      </s-box>
    </section>
  )
}
